<!-- <app-header-auth title="Client Credits"></app-header-auth> -->
<div class="container-fluid">
  <div class="row">
    <div class="col">
      <app-data-table [columns]="columns" [loadPage]="loadPage" [(filters)]="filters" [filtersComponent]="dataFilters"
        [pageSize]="15">
        <app-data-filters #dataFilters [showExcelExportButton]="true">
          <app-data-filter-group>
            <app-data-filter-input label="{{'orders.credits.creditId' | translate}}" [(model)]="filters.id"
              placeholder="{{'orders.credits.creditId' | translate}}">
            </app-data-filter-input>
            <app-data-filter-input label="{{'orders.credits.creditCode' | translate}}" [(model)]="filters.code"
              placeholder="{{'orders.credits.creditCode' | translate}}">
            </app-data-filter-input>
            <app-data-filter-input label="{{'orders.credits.clientName' | translate}}" [(model)]="filters.clientName"
              placeholder="{{'orders.credits.clientName' | translate}}">
            </app-data-filter-input>
            <app-data-filter-datepicker label="{{'orders.credits.createdFrom' | translate}}"
              [(model)]="filters.createdFrom"></app-data-filter-datepicker>
            <app-data-filter-datepicker label="{{'orders.credits.createdTo' | translate}}"
              [(model)]="filters.createdTo"></app-data-filter-datepicker>
            <app-data-filter-datepicker label="{{'orders.credits.consumedFrom' | translate}}"
              [(model)]="filters.consumedFrom"></app-data-filter-datepicker>
            <app-data-filter-datepicker label="{{'orders.credits.consumedTo' | translate}}"
              [(model)]="filters.consumedTo"></app-data-filter-datepicker>
          </app-data-filter-group>
        </app-data-filters>
      </app-data-table>

      <ng-template #contractId let-creditId="creditId">
        {{creditId}}
      </ng-template>

      <ng-template #creditCode let-creditCode="creditCode">
        {{creditCode}}
      </ng-template>

      <ng-template #creditTitle let-creditTitle="creditTitle">
        {{creditTitle}}
      </ng-template>

      <ng-template #createdDate let-createdDate="createdDate">
        {{createdDate | date:'dd-MM-yyyy'}}
      </ng-template>

      <ng-template #consumedDate let-consumedDate="consumedDate">
        {{consumedDate | date:'dd-MM-yyyy'  }}
      </ng-template>

      <ng-template #amount let-amount="amount">
        {{amount | currency:'€ '}}
      </ng-template>

      <ng-template #consumed let-consumed="consumed">
        {{consumed | currency:'€ '}}
      </ng-template>

      <ng-template #remaining let-remaining="remaining">
        {{remaining | currency:'€ '}}
      </ng-template>

      <ng-template #expiredDate let-expiredDate="expiredDate">
        {{expiredDate | date:'dd-MM-yyyy'  }}
      </ng-template>

      <ng-template #status let-status="status">
        {{status | creditsStatus | translate}}
      </ng-template>

      <ng-template #actions let-creditId="id" let-creditCode="creditCode" let-status="status" let-consumedFrom="consumedFrom" let-creditTitle="creditTitle">
        @if (status === 0) {
          <a href="/orders/credit-paper/{{creditCode}}" target="_blank" class="btn btn-sm btn-primary"><i
            class="fa fa-print"></i></a>
        }
        @if (accountType === 'admin' && status === 0) {
          <button type="button" class="btn btn-sm btn-danger"
              (click)="onCreditCloseButtonClick(content, creditId, creditCode, creditTitle)">{{'orders.allOrders.close' | translate}}</button>
        }
        @if (status === 1 || status === 2) {
          {{consumedFrom === 1 ? ('orders.credits.closedManually' | translate) : ('orders.credits.closedApp' | translate)}}
        }
      </ng-template>

      <ng-template #content let-modal>
        <div class="modal-header">
          <div class="col">
            <h5 class="modal-title" id="modal-basic-title">
              {{'orders.credits.closeCredit' | translate}} - {{currentCreditTitle}}</h5>
            <div style="font-size: medium">{{'orders.credits.creditCode' | translate}}: {{currentCreditCode}}</div>
          </div>
          <button type="button" class="close" aria-describedby="modal-title"
            (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row" style="justify-content: center; margin-bottom: 10px">
            <app-data-filter-datepicker style="width: 40%; margin-right: 10px" [(model)]="creditClosingDate" label="{{'orders.allOrders.closeDate' | translate}}"></app-data-filter-datepicker>
            <kendo-label text="{{'orders.allOrders.closeTime' | translate}}" [style.width.%]="20" [style.margin-right.px]="10">
              <kendo-timepicker format="HH:mm" [(value)]="creditClosingTime"></kendo-timepicker>
            </kendo-label>
            <kendo-label text="{{'orders.credits.closeAmount' | translate}}" [style.width.%]="20">
              <kendo-numerictextbox [(value)]="consumedAmount" [min]="0"></kendo-numerictextbox>
            </kendo-label>
          </div>
          <div *ngIf="showAmountError" class="text-danger text-right" style="margin-top: -5px; margin-right: 30px">{{'credit.amountWarning' | translate}}</div>
          <p style="text-align: center;"><strong>{{'orders.credits.closeCreditMsg' | translate}}</strong></p>
          <p style="text-align: center;">
            <span class="text-danger bold">{{'orders.credits.closeCreditWarning' | translate}}</span>
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary"
            (click)="modal.dismiss('cancel click')">{{'orders.allOrders.cancel' | translate}}</button>
          <button type="button" class="btn btn-outline-success"
            (click)="closeModal(modal)">{{'orders.allOrders.ok' | translate}}</button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
